import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const LeadStatusLayout = () => {
  const navList = useNav();
  let { leadStatusBottomHeader, leadStatusTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={leadStatusBottomHeader} topTabs={leadStatusTopHeader} />
      <Outlet />
    </div>
  );
};

export default LeadStatusLayout;
